import {
  EnvelopeDTO,
  CompanyDTO,
  AddressDTO,
  ProcurementProjectDTO,
  CircuitoDTO,
  ObjectContextDTO,
  PublicationInfoDTO,
  AwardDTO,
  ProjectEntityDTO,
  ProcurementProjectLotDTO,
  ContractDTO,
  InvoiceDTO,
  ExpenseManagementDTO,
  CommunicationDTO,
  ContractModificationDTO,
  AccountingDocumentDTO,
  RegisterContractModificationDTO,
  ValidationResultDTO,
  ActionDefinitionDTO,
  DebtInquiriesDTO,
  CommunicationActivityDTO,
  CommunicationChannelDTO,
  CustomFieldDisplayDTO,
  CustomFieldDTO
} from './plyca-dtos-v2';
import { WorkAssignManagerDTO } from '../tasks/assignManager/model/assignManager.model';
import { WorkTaskAssignmentDTO } from '../tasks/taskAssignment/model/taskAssignment.model';
import { MasterData } from './contract-notice-dto';
import { WorkOrderProjectDTO, WorkBudgetaryProjectDTO } from './sarga-dtos';
import { WorkFinanceProjectDTO, WorkIncomeDTO } from './bsm-dtos';
import { WorkTenderClassificationDTO } from '../tasks/tenderClassification/model/tenderClassification.model';
import { WorkCertificationPaymentDTO, WorkSpendingProjectDTO } from './dipbad-dtos';

// Generated using typescript-generator version 1.11.232 on 2017-02-02 12:30:21.
export class BaseObject {
  identifier: string;
  links: Link[];
  task: TaskDTO;
}

export interface SearchSettingActionGroupDTO
  extends BaseObjectDTO<string>,
  IObjectDTO<string>,
  IDescribable {
  listActionGroup: ActionDTO[];
  parent: SearchSettingActionGroupDTO;
}

export interface SearchSettingColumnDTO
  extends BaseObjectDTO<DossierTypeDTO>,
  IObjectDTO<DossierTypeDTO>,
  IDescribable {
  jsonFields: string[];
  typeColumn: string;
  columnDefault: boolean;
  orderedByDefault: boolean;
  visibility: boolean;
}
export interface SearchSettingFilterDTO
  extends BaseObjectDTO<DossierTypeDTO>,
  IObjectDTO<DossierTypeDTO>,
  IDescribable {
  listInformationFilter: SearchSettingInformationFilterDTO[];
}

export interface SearchSettingDTO
  extends BaseObjectDTO<DossierTypeDTO>,
  IObjectDTO<DossierTypeDTO> {
  columnsSearch: SearchSettingColumnDTO[];
  filtersSearch: SearchSettingFilterDTO[];
  typeDossier: DossierTypeDTO;
  paginated: boolean;
}

export interface SearchSettingRestrictionFilterDTO
  extends BaseObjectDTO<string>,
  IObjectDTO<string> {
  lengthField: string;
  listFieldExclusive: string[];
  listFieldRelated: string[];
  listIllegalCharacter: string[];
}
export interface SearchSettingInformationFilterDTO
  extends BaseObjectDTO<string>,
  IObjectDTO<string> {
  jsonField: string;
  linkDTO: LinkDTO;
  restrictions: SearchSettingRestrictionFilterDTO;
  tooltip: string;
  type: SearchSettingTypeFilterDTO;
  possibleValues: MasterDataDTO[];
}

export interface DossierDTO extends BaseObjectDTO<string> {
  accions: SearchSettingActionGroupDTO[];
  datos: string;
  division: DivisionDTO;
  estado: MasterDataDTO;
  phase: MasterDataDTO;
  expedienteId: string;
  opcTramitacion: number;
  sitArchivado: string;
  situacion: number;
  titulo: string;
  uuid: string;
  userAllowedForSupport: boolean;
}

export class ActionDTO {
  identifier: string;
  name: string;
  description: string;
  icon: string;
  enabled: boolean;
  visible: boolean;
  needsPreparation: boolean;
  parameters: ActionParameterDTO[];
  link: LinkDTO;
  definition: ActionDefinitionDTO;

  links: Array<Link>;
  target: any;
}

export class ActionExecutionRequestDTO {
  identifier: string;
  task: TaskDTO;

  action: ActionDTO;
  async: boolean;
  completionPercentage: number;
  description: string;
  executions: Array<ActionExecutionDTO>;
  links: Array<Link>;
  node: string;
  onStartUp: boolean;
  parallel: false;
  resourceType: string;
  state: ActionExecutionState;
  targets: Array<ActionExecutionTargetDTO>;
  user: UserDTO;
}

export class ActionExecutionDTO {
  identifier: string;
  completionPercentage: number;
  creationDate: Date;
  endDate: Date;
  executionDate: Date;
  message: string;
  state: ActionExecutionState;
  target: ActionExecutionTargetDTO

  waypoints: Array<ActionExecutionWaypointDTO>;
}

export enum ActionExecutionState {
  NOT_STARTED = 'NOT_STARTED',
  RUNNING = 'RUNNING',
  CANCELLED = 'CANCELLED',
  NOT_EXECUTABLE = 'NOT_EXECUTABLE',
  NOT_ALLOWED = 'NOT_ALLOWED',
  SUCCESS = 'SUCCESS',
  ERROR = 'ERROR'
  // WARNING = 'WARNING'
}

export class ActionExecutionWaypointDTO {
  identifier: string;
  eventDate: Date;
  level: ActionExecutionWaypointLevelDTO;
  message: string;
}

export enum ActionExecutionWaypointLevelDTO {
  WARNING = 'WARNING',
  INFO = 'INFO',
  ERROR = 'ERROR'
}

export class ActionExecutionTargetDTO {
  identifier: string;
  target: string;
  description: string;
}

export class ActionParameterDTO {
  identifier: string;
  jsonPath: string;
  name: string;
  value: any;
  description: string;
  required: boolean;
  type: any;
  formFieldType: any;
  visible: boolean;
  editable = true;
  possibleValues: MasterData[];
  actionType: ActionParameterTypeDTO;
  maxLength: number;
  minLength: number;
}

export class ActionParameterTypeDTO {
  static INTEGER = 'Integer';
  static BOOLEAN = 'Boolean';
  static STRING = 'String';
  static CONST = 'Const';
}

export interface AnnuityApplicationDTO
  extends BaseObjectDTO<string>,
  IObjectDTO<string> {
  anuEconomica: string;
  anuEconomicaInicial: string;
  anuFuncional: string;
  anuFuncionalInicial: string;
  anuOrganica: string;
  anuOrganicaInicial: string;
  anualidadId: number;
  cGasto: string;
  ctaPGCP: string;
  docContableNumOrden: number;
  ejercicio: string;
  importe: number;
  listaDocId: string;
  loteId: number;
  presupAno: string;
  presupAnoInicial: string;
  propuestaId: string;
  proyInvId: string;
  remesa: string;
}

export interface AssignedServiceProjectDTO
  extends BaseObjectDTO<string>,
  IObjectDTO<string> {
  idOrganismo: string;
  organismoNombre: string;
  propuestaId: string;
  tipo: string;
  uuid: string;
}

export interface AttributeDTO
  extends BaseObjectDTO<string>,
  IDescribable,
  IFilterDTO {
  attributeNumber: string;
  entity: string;
  group: string;
  inParameters: AttributeParameterDTO[];
  outParameters: AttributeParameterDTO[];
  statistics: AttributeStatsDTO;
  type: AttributeTypeDTO;
  valid: boolean;
}

export interface AttributeParameterDTO extends INameable, IDescribable {
  type: DataTypeDTO;
}

export interface AttributeStatsDTO { }

export interface AttributeResultDTO {
  values: AttributeValueDTO[];
}

export interface AttributeDataDTO {
  name: string;
  description: string;
  type: DataTypeDTO;
  value: any;
}

export interface AttributeValueDTO extends BaseObjectDTO<string> {
  columns: any;
}

export interface AuditTaskDTO extends BaseObjectDescribableDTO<string> {
  dateArrival: Date;
  dateDesp: Date;
  dateOpen: Date;
  iteration: number;
  procedure: ProcedureDTO;
  project: ProjectEntityDTO;
  procedureId: string;
  profile: UserProfile;
  swIdTask: string;
  taskId: string;
  user: UserDTO;
  inbox: InboxDTO;
  rule: boolean;
  profiles: ProfileDTO[];
}

export interface BaseObjectDTO<ID> extends IObjectDTO<ID> {
  links: Link[];
}

export interface BaseObjectDescribableDTO<ID>
  extends BaseObjectDTO<ID>,
  IDescribable { }

export interface BaseObjectNameableDTO<ID>
  extends BaseObjectDTO<ID>,
  INameable { }

export interface BaseSubordinateIdDTO<ID, T> extends ISubordinateIdDTO<ID, T> { }

export interface BaseSubordinateObjectDTO<ID>
  extends BaseObjectDTO<ID>,
  ISubordinateObjectDTO<ID> { }

export interface CofinancingDTO
  extends BaseObjectDTO<string>,
  IObjectDTO<string> {
  anoPartida: number;
  cofinanciacionId: number;
  desEntidad: string;
  division: number;
  entidad: string;
  fechaAprobacion: Date;
  imporPartida: number;
  partida: string;
  porcentaje: number;
  propuestaid: string;
  proyecto: string;
  uuid: string;
}

// export interface CompanyDTO extends BaseObjectDTO<string> {
//   empresaDNICIF: string;
//   nombreComercial: string;
//   razonSocial: string;
//   tipoPersonalidad: MasterDataDTO;
// }

export interface CompanyDossierDTO extends DossierDTO {
  company: CompanyDTO;
  ultimoEstado: MasterDataDTO;
}

export class DivisionDTO {
  identifier: string;
  task: TaskDTO;
  children: DivisionDTO[];
  name: string;
  documentClass: DocumentClassDTO;
  parent: DivisionDTO;
  phase: MasterDataDTO;
  procedure: MasterDataDTO;
  startDate: Date;
  usuid: string;
  project: ProjectEntityDTO;
  type: MasterDataDTO;
  hierarchicalDescription: string;
}

export interface IChildOfDivision {
  division: DivisionDTO;
}

export type ExecutionDivisionStatusTypeDTO =
  | 'NOT_RUNNING'
  | 'RUNNING_RESTRICTED'
  | 'RUNNING'
  | 'PAUSED'
  | 'CLOSED';


export class ExecutionDivisionDTO extends DivisionDTO {
  executionStatus: ExecutionDivisionStatusTypeDTO;
  certificationName: string;
  certificationsMode: boolean;
}

export type SignatureLevelDTO =
  | 'Basic'
  | 'WithTime'
  | 'WithLongTermValidation'
  | 'WithLongTermAvailability';

export type SignatureUpgradeScopeDTO =
  | 'allSignatures'
  | 'lastSignature'
  | 'selectedSignature';

export class SignatureUpgradeDTO {
  desiredLevel: SignatureLevelDTO;
  upgradeScope: SignatureUpgradeScopeDTO;
  b64TargetCertificate: string;
  appliesTo: SignatureFormatDTO;
}

export interface DocumentClassConfigurationDTO {
  allowedFileExtensions: string[];
  allowedSignatureFormats: SignatureFormatDTO[];
  preferredSignatureFormats: SignatureFormatDTO[];
  signatureValidation: SignatureValidationDTO;
  allowMultipleFiles: boolean;
  allowMultipleSignatures: boolean;
  allowInvalidSignatures: boolean;
  invalidSignaturesPolicy: InvalidSignaturesPolicy;
  maximumFileSize: number;
  table: string;
  generateTemplateAuto: boolean;
  pdfConversionEnabled: boolean;
  multidocument: boolean;
  signatureUpgradeConfiguration: SignatureUpgradeDTO[];
}

export type InvalidSignaturesPolicy = 'MANDATORY' | 'RECOMMENDATION' | 'NONE';


export class DocumentClassDTO {
  identifier: string;
  name: string;
  links: Link[];
  task: TaskDTO;
  abbreviation: string;
  application: string;
  configuration: DocumentClassConfigurationDTO;
}



export interface SignatureValidationDTO {
  signatureValidationPolicy: SignatureValidationPolicy;
  signaturesAllowed: boolean;
  signaturesRequired: boolean;
}

export interface BaseEntityDTO extends BaseObjectDTO<any> {
  division: DivisionDTO;
  documentClass: DocumentClassDTO;
  orderNumber: number;
}

export class RelatedDocumentDTO {
  relation: MasterDataDTO;
  document: DocumentDTO;
  readOnly: boolean;
  visible: boolean;
}

export enum DOCUMENT_SELECTION_MODE {
  SELECTION_MODE_OFF = 0,
  SELECTION_MODE_SINGLE_SELECTION = 1,
  SELECTION_MODE_MULTIPLE_SELECTION = 2
}
export class DocumentDTO {
  identifier: string;
  task: TaskDTO;
  name: string;
  comment: string;
  creationDate: Date;
  currentState: DocumentStateDTO;
  currentVersion: DocumentVersionDTO;
  entity: BaseEntityDTO;
  extendedDataIdentifier: any; //
  folder: any; //
  markedAsCompleted: boolean;
  phase: MasterDataDTO;
  stateHistory: DocumentStateDTO[];
  type: DocumentFileTypeDTO;
  user: UserDTO;
  versionHistory: DocumentVersionDTO[];
  customFieldDefinitions: any;
  customFields: any;
  relatedDocuments: RelatedDocumentDTO[];
  availableActions: LinkedActionsDTO;
  locale: string;
  date: Date;
  availableForCorrection: boolean;
  thirdParty: any;
  hidden: boolean;
  static patchDTO(dto: DocumentDTO): DocumentDTO {
    if (!dto) {
      dto = new DocumentDTO();
    } else {
      if (!dto.entity) {
        dto.entity = <BaseEntityDTO>{};
      }
      if (!dto.currentVersion) {
        dto.currentVersion = {} as DocumentVersionDTO;
        dto.currentVersion.files = [] as FileDetailsDTO[];
      }
      if (!dto.customFields) {
        dto.customFields = {};
      }
      if (!dto.customFieldDefinitions) {
        dto.customFieldDefinitions = {};
      }
    }
    return dto;
  }

  constructor() {
    DocumentDTO.patchDTO(this);
  }
}

export interface DocumentFileDTO extends DownloadableDTO {
  type: DocumentFileTypeDTO;
}

export interface TmpFileDTO extends DownloadableDTO {
  b64Content: string;
  comment: string;
  desiredSignatureUpgrade: SignatureUpgradeDTO;
}

export interface DocumentFileIdDTO
  extends BaseSubordinateIdDTO<number, DocumentVersionDTO> { }

export interface DocumentFolderDTO extends BaseObjectDTO<string>, INameable {
  folders: DocumentFolderDTO[];
  documents: DocumentDTO[];
}

export interface DocumentFolderFilterDTO extends IFilterDTO {
  parent: string;
  dossierId: string;
}

export class DocumentStateDTO {
  identifier: string;
  links: Link[];
  task: TaskDTO;
  comment: string;
  type: MasterDataDTO;
  user: UserDTO;
  rejectionState: boolean;
  correctionState: true;
  date: Date;
  systemDate: Date;
}

export class DocumentVersionDTO {
  identifier: string;
  task: TaskDTO;
  links: Link[];
  date: Date;

  files: FileDetailsDTO[];
  released: boolean;
  user: UserDTO;
  verificationCode: string;
  versionNumber: number;
  type: DocumentFileTypeDTO;
  signers: DocumentSignerDTO[];
  externalIdentifier: string;
}
export class DocumentSignerDTO {
  // En servidor tiene mas propiedades
  name: string;
}

export interface DocumentVersionIdDTO
  extends BaseSubordinateIdDTO<number, DocumentDTO> { }

export interface DownloadableDTO extends BaseObjectDTO<string>, INameable {
  fileDetails: FileDetailsDTO;
  name: string;
  target: string;
  mimeType: string;
  class: string;
}

export interface Entry<K, V> {
  key: K;
  value: V;
}

export interface ICommentable {
  comment: string;
}

export interface IDatable {
  date: Date;
}

export interface IDescribable {
  description: string;
}

export interface IDownloadable {
  download: DownloadableDTO;
}

export interface IFilterDTO { }

export interface INameable {
  name: string;
}

export interface IObjectDTO<ID> {
  // expand: string[];
  identifier: ID;
  task: TaskDTO;
  context?: ObjectContextDTO;
}

export interface ISignable extends IDownloadable {
  signatures: SignatureDTO[];
}

export interface ISubordinateIdDTO<ID, T> {
  identifier: ID;
  parent: T;
}

export interface ISubordinateObjectDTO<ID> extends IObjectDTO<ID> { }

export interface IUploadDTO extends IObjectDTO<string> {
  action: ActionDTO;
}

export interface Identifiable<ID> {
  id: ID;
}

export interface Link {
  href: string;
  rel: string;
}

export interface LinkDTO {
  target: IObjectDTO<string>;
  type: LinkRelationDTO;
  verb: string;
}

export interface LoggerDTO {
  level: string;
  name: string;
}

export interface LoginRequest {
  applicationId: string;
  password: string;
  profileId: number;
  userName: string;
}

export interface LoginResponse {
  accessToken: string;
  refreshToken: string;
  tokenType: string;
  user: UserDTO;
  version: string;
}

export interface PasswordStrengthDTO {
  valid: boolean;
  strength: string;
  cause: string;
}

export interface ChangePasswordRequestDTO {
  token: string;
  userId: string;
  newPassword: string;
  verificationCode: string;

}

export class MasterDataDTO {
  description?: string;
  links?: Link[];
  identifier?: string;
  task?: TaskDTO;
  properties?: Map<string, any>;

  constructor(identifier: string, type: string) {
    this.identifier = createIdentifier(identifier, type);
  }
}

export interface MasterDataTableDTO
  extends BaseObjectDTO<MasterDataTypeDTO>,
  IObjectDTO<MasterDataTypeDTO> {
  nameFields: string;
  nameTable: string;
}

export class OrganizationalUnitDTO {
  links: Link[];
  // expand: string[];
  identifier: string;
  task: TaskDTO;

  cif: string;
  entity: boolean;
  entityDTO: OrganizationalUnitDTO;
  fecAddModi: Date;
  fecPubli: Date;
  headLine1: string;
  headLine2: string;
  headLine3: string;
  headLine4: string;
  pathUnit: string;
  unitAsRecruiting: boolean;
  unitId: string;
  name: string;
  unitParent: OrganizationalUnitDTO;
  customFieldDefinitions: any;
  customFields: any;
  activeModules: ModuleDTO[];
  activeLocales: String[];
}

export class ModuleDTO {
  active: boolean;
  identifier: string;
}

export interface PersonDTO extends BaseObjectNameableDTO<string> {
  email: string;
  lastName: string;
  position: string;
  receiveNotifications: boolean;
  surname: string;
  fullName: string;
  typeIdentification: MasterDataDTO;
}

export interface PlanDossierDTO extends DossierDTO {
  afectada: boolean;
  anoFin: string;
  anoInicio: string;
  comunitaria: boolean;
  descatalogado: boolean;
  fecha: Date;
  observaciones: string;
  presupFinal: number;
  presupInicial: number;
  recurso: boolean;
  representacion: string;
  tipoAprobacion: MasterDataDTO;
}

export interface ProcedureDTO extends ITaskDataDTO {
  task: TaskDTO;
  definition: ProcedureDefinition;
  description: string;
  endDate: Date;
  lastModified: Date;
  lastSaveTaskId: string;
  lastStateDate: Date;
  processIdentifier: string;
  startDate: Date;
  startInfo: StartInfo;
  status: ProcedureStatusDTO;
  children: ProcedureDTO[];
  documentClass: DocumentClassDTO;
  circuit: CircuitoDTO;
  division: DivisionDTO;
  phase: MasterDataDTO;
  procedureType: any;
  availableActions: LinkedActionsDTO;
  ancesters: string;
}

export interface ProcedureDefinition {
  description: string;
  identifier: string;
}

export interface ProcedureIdDTO
  extends BaseObjectDTO<string>,
  ISubordinateIdDTO<string, ProjectEntityDTO> { }

export interface ProcurementDossierDTO extends DossierDTO {
  adjDescripcion: string;
  adjDisplegales: string;
  adjProcedimiento: string;
  adjRazonesJust: string;
  aiTexto: string;
  alias: string;
  anoPresupuesto: string;
  anoinicio: string;
  anualidadesIni: string;
  cCentralizadaId: number;
  cCentralizadaOrgId: string;
  cCentralizadaTipo: number;
  categoriaExpteId: string;
  claseExpId: MasterDataDTO;
  cpvId: string;
  ctapgcp: string;
  economica: string;
  expOrigen: string;
  expedientePadre: string;
  fAdjId: MasterDataDTO;
  funcional: string;
  idSistComplementario: MasterDataDTO;
  importeAdj: number;
  importePresup: number;
  lotes: boolean;
  modalidadExpteId: string;
  modifContrato: boolean;
  modoTramitacion: MasterDataDTO;
  numAplicaciones: string;
  numRefFlujo: string;
  organica: string;
  prClaseOpera: number;
  presupSinIva: number;
  provinciaId: string;
  proyectoAsociado: number;
  situacionEstado: string;
  subtipoExpteId: string;
  tipoExpteId: MasterDataDTO;
  tipoGesId: string;
  tipoPresup: number;
  tituloContrato: string;
  tramanticipada: boolean;
  valorEstimado: number;
}

export interface ProjectDossierDTO extends DossierDTO {
  anualidades: AnnuityApplicationDTO[];
  carretera: string;
  centro: string;
  codigoActivo: string;
  eje: string;
  entidad: string;
  expedienteIdPadre: string;
  expedientePadre: PlanDossierDTO;
  indicadores: ProjectIndicatorDTO[];
  medida: MasterDataDTO;
  modificaciones: ProjectModificationsDTO[];
  numProyecto: string;
  observaciones: string;
  observacionesParticipes: string;
  participes: CofinancingDTO[];
  representacionPadre: string;
  servidosAsignados: AssignedServiceProjectDTO[];
  tipoAprobacion: number;
  tipoCreacionExpediente: string;
  tipoInversion: string;
  tipoObra: string;
  tituloPadre: string;
  totalProyecto: number;
}

export interface ProjectIndicatorDTO
  extends BaseObjectDTO<string>,
  IObjectDTO<string> {
  activo: number;
  cantidad: number;
  descripcion: string;
  descripcionCorta: string;
  idIndicador: string;
  orden: number;
  propuestaId: string;
  representacionIndicador: string;
  tipoIndicador: MasterDataDTO;
}

export interface ProjectModificationsDTO
  extends BaseObjectDTO<string>,
  IObjectDTO<string> {
  codigoModificacion: MasterDataDTO;
  fechaModificacion: Date;
  idModificacion: number;
  observaciones: string;
  tipoModificacion: MasterDataDTO;
}

export interface ResourceDTO extends ResourceSupport { }

export class HashDataDTO {
  value: string;
  algorithm: string;
}
export class FileDetailsDTO
  implements
  BaseObjectDTO<string>,
  ISignable,
  INameable,
  IDownloadable,
  ResourceDTO {
  id: Link;
  name: string;
  signatures: SignatureDTO[];
  links: Link[];
  identifier: string;
  task: TaskDTO;
  size: number;
  nameWithSignatures: string;
  fileType: DocumentFileTypeDTO;
  fileSubType: any;
  target: FileDetailsDTO;
  download: DownloadableDTO;
  hash: HashDataDTO;
  description: string;
  showFileOnDownload = false;

  static isPDF(fileItem: FileDetailsDTO): boolean {
    let isPDF: boolean;
    if (fileItem) {
      if (fileItem instanceof BlobFileDetails) {
        let blob = (<BlobFileDetails>fileItem).fileContent;
        isPDF = blob && (blob.type === 'application/pdf');
      } else {
        let name: string = fileItem.name;
        if (!name) {
          name = '';
        }
        isPDF = fileItem &&
          name.toUpperCase().substring(name.lastIndexOf('.') + 1) === 'PDF';
      }
    }
    return isPDF;
  }
}

export class BlobFileDetails extends FileDetailsDTO {
  fileContent: Blob;
}

export interface ResourceSupport extends Identifiable<Link> {
  links: Link[];
}

export interface SessionDTO extends BaseObjectDTO<string>, IObjectDTO<string> {
  lastRequestTime: Date;
  userName: string;
}

// export interface SignatureDetailsDTO
//   extends BaseObjectDTO<string>,
//     ISignable,
//     IDatable,
//     ICommentable {
//   file: FileDetailsDTO;
//   mode: SignatureMode;
//   signedParent: ISignable;
//   signer: string;
//   type: SignatureType;
//   certificate: CertificateDetailsDTO;
//   verified: boolean;
//   integrityValid: boolean;
//   error: boolean;
//   validationMessages: string[];
//   position: string;
//   signatureFormat: SignatureFormatDTO;
// }

export interface SignatureFormatDTO {
  aFirmaFormat: AFirmaFormatType;
  aFirmaAlgorithm: AFirmaAlgorithmType;
  aFirmaParams: Map<string, string>;
  type: SignatureType;
  mode: SignatureMode;
  oneSignaturePerFile: boolean;
  maximumFileSize: number;
  signingFileExtensions: string[];
}

export interface CertificateDetailsDTO
  extends BaseObjectDTO<number>,
  ISignable,
  IDatable,
  ICommentable {
  ok: boolean;
  expiredOrNotValidYet: boolean;
  revoked: boolean;
  issuer: string;
  commonName: string;
  fileBASE64: string;
  thumbprint: string;
  thumbprintAlgorith: string;
}

export interface StartInfo {
  procedure: ProcedureDTO;
  user: UserDTO;
  comment: string;
}

export class UserProfileDTO implements BaseObjectDTO<string> {
  links: Link[];
  identifier: string;
  task: TaskDTO;
  profile: ProfileDTO;
  user: UserDTO;
  application: string;
  uuid: string;

}
export class UserOrgsDTO implements BaseObjectDTO<string> {
  links: Link[];
  identifier: string;
  task: TaskDTO;
  org: OrganizationalUnitDTO;
  user: UserDTO;
  visibilityOnly: boolean;
  uuid: string;

}

export class InboxUserDTO {

  inbox: InboxDTO;
  user: UserDTO;
  main: boolean;
  conditional: boolean;
  conditions: string;
  signComment: string;

}

export class UserQueryDTO implements BaseObjectDTO<string> {
  links: Link[];
  identifier: string;
  task: TaskDTO;
  query: QueryTypeDTO;
  user: UserDTO;
  application: string;
  uuid: string;

}
export interface InboxProfileDTO extends BaseObjectDTO<string> {
  profile: ProfileDTO;
  inbox: InboxDTO;
  application: string;
  uuid: string;

}
export interface UserAccessDTO {
  substitution: any;
  inboxAccess: boolean;
  substitutionAccess: boolean;
  exclusiveAccess: boolean;
  description: boolean;

}

export interface InboxDTO extends BaseObjectDTO<string> {
  locked: boolean;
  name: string;
  organizationalUnit: OrganizationalUnitDTO;
  // Service
  main: boolean;
  conditional: boolean;
  conditions: string;
  signComment: string;
  inboxProfiles: InboxProfileDTO[];
  inboxUsers: UserDTO[];
  // Facade
  profiles: ProfileDTO[];
  usersWithAccess: UserAccessDTO[];
  definitive: boolean;

}

export interface ITaskDataDTO extends BaseObjectDTO<string> {
  taskData: TaskDataDTO[];
}

export interface TaskDTO extends ITaskDataDTO {
  arrivalDate: Date;
  availableActions: LinkedActionsDTO;
  choiceGroup: string;
  choiceOrder: number;
  choiceSubgroup: string;
  description: string;
  dossier: DossierDTO;
  division: any;
  expirationDate: Date;
  groupId: string;
  inbox: InboxDTO;
  lockedBy: UserDTO;
  lockedForSupport: boolean;
  name: string;
  plycaTaskId: string;
  procedure: ProcedureDTO;
  profile: UserProfile;
  status: TaskStatusDTO;
  type: TaskTypeDTO;
  work: WorkDTO;
  workType: WorkTypeDTO;
  workAvailable: boolean;
  validationResult: ValidationResultDTO;
}

export class LinkedActionsDTO {
  parameters: ActionParameterDTO[];
  actions: Array<ActionDTO>;
}

export interface TaskDataDTO {
  name: string;
  procedureVarName: string;
  readOnly: boolean;
  type: string;
  value: any;
}

export interface TaskFilterDTO extends IFilterDTO {
  appId: string;
  displayLckd: boolean;
  displayLogicallyLckd: boolean;
  dossier: string;
  fromDate: Date;
  groupId: string[];
  profiles: number[];
  toDate: Date;
  types: TaskTypeDTO[];
  userName: string;
}

export interface UserApplication {
  descripcion: string;
  id: string;
}

export class Locale {
  language: string;
  country: string;
}
export class UserDTO implements BaseObjectDTO<string> {
  links: Link[];
  identifier: string;
  task: TaskDTO;
  dateLastTaskQuery: Date;
  dateSignature: boolean;
  hasSignature: boolean;
  lastEntryDate: Date;
  locked: boolean;
  organizationalUnit: OrganizationalUnitDTO;
  person: PersonDTO;
  redirectTask: boolean;
  signatureInPorta: boolean;
  uuid: string;
  listProfiles: Array<ProfileDTO>;
  userProfiles: Array<UserProfileDTO>;
  inboxes: Array<InboxDTO>;
  requires2FA: boolean;
  authenticated2FA: boolean;
  userQueries: Array<UserQueryDTO>;
  accessSupport: boolean;
  customFields: any;
  password: string;
  userOrgs: Array<UserOrgsDTO>;
  userInboxes: Array<InboxUserDTO>;
  locale: Locale;

  static patchDTO(dto: UserDTO): UserDTO {
    if (!dto) {
      dto = new UserDTO();
    } else {
      // dto.organizationalUnit = OrganizationalUnitDTO.patchDTO (dto.organizationalUnit);
      // dto.person = PersonDTO.patchDTO (dto.person);
      // if (!dto.listProfiles) {
      //   dto.listProfiles = [];
      // }
      if (!dto.inboxes) {
        dto.inboxes = [];
      }
    }
    return dto;
  }

  contructor() {
    UserDTO.patchDTO(this);
  }
}
export enum LogicOperatorType {

  EQ = '==',
  NE = '!=',
  LT = '<',
  LE = '<=',
  GT = '>',
  GE = '>=',
  IN = 'in',
  NI = 'ni'


}
export enum ProfileRoleTYPE {
  SIGNER = 'SIGNER',
  DISPATCHER = 'DISPATCHER'
}
export enum ProtocolProfileType {
  INBOX = 'INBOX',
  ATTRIBUTE = 'ATTRIBUTE'
}
export class ProtocolProfileDTO implements BaseObjectDTO<string> {
  links: Link[];
  identifier: string;
  task: TaskDTO;

  protocol: ProtocolDTO;
  profile: ProfileDTO;
  order: number;
  attribute: AttributeDTO;
  inbox: InboxDTO;
  protocolProfileType: ProtocolProfileType;
  profileRole: ProfileRoleTYPE;
  textRules: Array<TextRuleDTO>;



  locale: Locale;



  contructor() {

  }
}

export class TextRuleDTO implements BaseObjectDTO<string> {
  links: Link[];
  identifier: string;
  task: TaskDTO;

  locale: Locale;

  attribute: AttributeDTO;
  logicOperator: LogicOperatorType;
  condition: string;
  value: string;
  order: number;
  objectUUID: string;
  objectDocumentClass: DocumentClassDTO;



  contructor() {

  }
}
export class ProtocolDTO implements BaseObjectDTO<string> {
  links: Link[];
  identifier: string;
  task: TaskDTO;

  organizationalUnit: OrganizationalUnitDTO;

  uuid: string;
  textRules: Array<TextRuleDTO>;
  protocolProfiles: Array<ProtocolProfileDTO>;

  customFields: any;
  description: string;
  order: number;

  locale: Locale;
  application: string;
  enabled: boolean;



  contructor() {

  }
}

export class ProfileDTO implements IObjectDTO<string> {
  task: TaskDTO;
  identifier: string;
  name: string;
  description: string;
  application: string;
  uuid: string;

}

export class QueryTypeDTO implements IObjectDTO<string> {
  task: TaskDTO;
  identifier: string;

  description: string;
  application: string;
  uuid: string;

}

export interface UserProfile
  extends BaseObjectDTO<number>,
  IObjectDTO<number>,
  INameable {
  application: UserApplication;
  dynamic: boolean;
}

export interface WorkDTO
  extends WorkMessageDTO,
  WorkTaskAssignmentDTO,
  WorkAssignManagerDTO,
  WorkDocumentDTO,
  WorkDocumentSignatureDTO,
  WorkProcurementCommitteeDTO,
  TenderEvaluationCommitteeDTO,
  TenderValorationDTO,
  WorkPublicationInfoDTO,
  WorkContractDTO,
  WorkDebtInquiriesDTO,
  WorkProcurementProjectAwardsDTO,
  WorkTenderingDefinitionDTO,
  WorkInvoiceDTO,
  WorkExpenseManagementDTO,
  WorkTenderDTO,
  WorkContractMoficationDTO,
  WorkRegisterContractModificationDTO,
  WorkExpenseDocumentDTO,
  WorkCommunicationDTO,
  WorkOrderProjectDTO,
  WorkSpendingProjectDTO,
  WorkCertificationPaymentDTO,
  WorkBudgetaryProjectDTO,
  WorkIncomeDTO,
  WorkTenderClassificationDTO,
  WorkFinanceProjectDTO,
  WorkProcedureCircuitDTO,
  WorkPhaseChangeDTO {
  reactive: boolean;
  task: TaskDTO;
  validationResult: ValidationResultDTO;
  availableActions: LinkedActionsDTO;
}

export interface WorkDocumentDTO extends BaseObjectDTO<string> {
  document: DocumentDTO;
  index: number;
}

export interface WorkDocumentSignatureDTO extends BaseObjectDTO<string> {
  documents: Array<DocumentDTO>;
  index: number;
}

export interface WorkIdDTO
  extends BaseObjectDTO<string>,
  ISubordinateIdDTO<string, TaskDTO> { }

export interface WorkMessageDTO extends BaseObjectDTO<string> {
  defaultOption: string;
  message: string;
  notificacionid: string;
  options: Entry<string, string>[];
  selectedOption: string;
  uuidDoc: string;
}

export interface WorkPhaseChangeDTO extends BaseObjectDTO<string> {

  possiblePhases: MasterDataDTO[];
  selectedPhase: string;

}

export class ProcurementCommitteeDTO implements BaseObjectDTO<string> {
  links: Link[];
  identifier: string;
  task: TaskDTO;
  address: AddressDTO;
  division: DivisionDTO;
  date: Date;
  dateAdd: Date;
  dateModify: Date;
  description: string;
  documentAct: DocumentDTO;
  requestDocument: DocumentDTO;
  envelopes: Array<EnvelopeDTO>;
  members: Array<MemberProcurementCommitteeDTO>;
  phase: TenderingPhaseDTO;
  evaluationCommittee: TenderEvaluationCommitteeDTO;
  project: ProjectEntityDTO;
  quorum: number;
  state: ProcurementCommitteeState;

  static patchDTO(dto: ProcurementCommitteeDTO) {
    if (!dto.members) {
      dto.members = [];
    }
    if (!dto.phase) {
      dto.phase = new TenderingPhaseDTO();
    }

    if (!dto.evaluationCommittee) {
      dto.evaluationCommittee = new TenderEvaluationCommitteeDTO();
    }
    if (!dto.address) {
      dto.address = new AddressDTO();
    }
  }
  constructor() {
    ProcurementCommitteeDTO.patchDTO(this);
  }
}

export enum ProcurementCommitteeIdentificacionTypes {
  PLYCA = 'PLYCA',
  FRAGMENTOS = 'FRAGMENTOS'
}

export interface WorkProcurementCommitteeDTO extends BaseObjectDTO<string> {
  envelopes: EnvelopeDTO[];
  procurementCommitteeDTO: ProcurementCommitteeDTO;
  // members: MemberProcurementCommitteeDTO[];
  // numReleased: number;
  // quorum: number;
  // state;
}

export enum ProcurementCommitteeState {
  INITIAL = 'INITIAL',
  OPENING_DOC_GENERATING = 'OPENING_DOC_GENERATING',
  OPENING_DOC_GENERATED = 'OPENING_DOC_GENERATED',
  QUORUM_OK = 'QUORUM_OK',
  DECIPHER_IN_PROGRESS = 'DECIPHER_IN_PROGRESS',
  DECIPHERED = 'DECIPHERED',
  CLOSED = 'CLOSED'
}

export function getProcurementCommitteeStateValue(
  state: ProcurementCommitteeState
): number {
  let value = -1;
  switch (state) {
    case ProcurementCommitteeState.INITIAL: {
      value = 0;
      break;
    }
    case ProcurementCommitteeState.OPENING_DOC_GENERATING: {
      value = 10;
      break;
    }
    case ProcurementCommitteeState.OPENING_DOC_GENERATED: {
      value = 20;
      break;
    }
    case ProcurementCommitteeState.QUORUM_OK: {
      value = 30;
      break;
    }
    case ProcurementCommitteeState.DECIPHER_IN_PROGRESS: {
      value = 40;
      break;
    }
    case ProcurementCommitteeState.DECIPHERED: {
      value = 50;
      break;
    }
    case ProcurementCommitteeState.CLOSED: {
      value = 99;
      break;
    }
  }
  return value;
}

export interface ChildOfProjectDTO<T> extends BaseObjectDTO<T> {
  project: ProjectEntityDTO;
}

export class TenderEvaluationCommitteeDTO implements ChildOfProjectDTO<string> {
  project: ProjectEntityDTO;
  identifier: string;
  task: TaskDTO;
  codeMode: string;
  quorum: number;
  description: string;
  links: Link[];
  mandatoryProfiles: ProfileDTO[];
  procurementCommiteeDTO: ProcurementCommitteeDTO;
  memberTenderEvaluationCommittee: Array<MemberTenderEvaluationCommitteeDTO>;
}

export class TenderValorationDTO {
  project: ProjectEntityDTO;
  identifier: string;
  description: string;
  links: Link[];
}

export class MemberTenderEvaluationCommitteeDTO
  implements BaseObjectDTO<number> {
  links: Link[];
  identifier: number;
  task: TaskDTO;
  dateName: Date;
  certificatePerson: CertificatePersonDTO;
  provideCertificate: boolean;
  user: UserDTO;
  profile: ProfileDTO;
}

export class TenderingPhaseTypeDTO implements BaseObjectDTO<number> {
  links: Link[];
  identifier: number;
  task: TaskDTO;
  description: string;
  activity: string;
  envelopeTypes: MasterDataDTO;
  cipherMode: any; // CUSTODIO_PLYCA (0), SECRETO_COMPARTIDO (1), NO_CIFRADO (3);
}

export class TenderingPhaseDTO implements ChildOfProjectDTO<string> {
  project: ProjectEntityDTO;
  identifier: string;
  task: TaskDTO;
  links: Link[];
  state: TenderingPhaseState;
  envelopes: Array<EnvelopeDTO>;
  initDate: Date;
  endDate: Date;
  publications: Array<any>;
  type: TenderingPhaseTypeDTO;
  openingCommittees: Array<ProcurementCommitteeDTO>;
  cipherMode: CipherMode;

  public static getEnvelopesDescription(phase: TenderingPhaseDTO): string {
    let envelopes: string;
    if (phase.envelopes) {
      envelopes = phase.envelopes
        .sort((env1: EnvelopeDTO, env2: EnvelopeDTO) => env1.order - env2.order)
        .map((envelope: EnvelopeDTO) => envelope.description)
        .join(', ');
    }
    return envelopes;
  }
}

export enum CipherMode {
  CUSTODIO_PLYCA = 'CUSTODIO_PLYCA',
  SECRETO_COMPARTIDO = 'SECRETO_COMPARTIDO',
  NO_CIFRADO = 'NO_CIFRADO'
}

export enum TenderingPhaseState {
  CREATED = 'CREATED',
  PUBLICATION_PENDING = 'PUBLICATION_PENDING',
  PUBLISHED = 'PUBLISHED',
  CLOSED = 'CLOSED'
}

export interface WorkPublicationInfoDTO extends BaseObjectDTO<string> {
  identifier: string;
  context?: ObjectContextDTO;
  publicationInfo: PublicationInfoDTO;
}

export interface WorkContractDTO extends BaseObjectDTO<string> {
  identifier: string;
  context?: ObjectContextDTO;
  contract: ContractDTO;
}

export interface WorkProcurementProjectAwardsDTO extends BaseObjectDTO<string> {
  identifier: string;
  context?: ObjectContextDTO;
  awards: Array<AwardDTO>;
}

export interface WorkTenderingDefinitionDTO extends BaseObjectDTO<string> {
  identifier: string;
  view: TenderingDefinitionViews;
  activeViews: string[];
}

export interface WorkCommunicationDTO extends BaseObjectDTO<string> {
  identifier: string;
  communication: CommunicationDTO;
}

export interface WorkContractMoficationDTO extends BaseObjectDTO<string> {
  identifier: string;
  contractModification: ContractModificationDTO;
  context?: ObjectContextDTO;
}

export interface WorkRegisterContractModificationDTO extends BaseObjectDTO<string> {
  identifier: string;
  registerContractModification: RegisterContractModificationDTO;
  context?: ObjectContextDTO;
}



export interface WorkInvoiceDTO extends BaseObjectDTO<string> {
  identifier: string;
  context?: ObjectContextDTO;
  invoices: Array<InvoiceDTO>;

  /* Revisar */
  thirdPartyDescription: string;
  divisionIdentifier: string;
  projectIdentifier: string;
}




export interface WorkExpenseManagementDTO extends BaseObjectDTO<string> {
  identifier: string;
  context?: ObjectContextDTO;
  invoices: Array<InvoiceDTO>;
  division: DivisionDTO;

  /* Revisar */
  divisionIdentifier: string;
  projectIdentifier: string;
  expenseManagementDTO: ExpenseManagementDTO; // Gestion del Gasto
  exercise: String;
  award: AwardDTO;
}


export interface WorkExpenseDocumentDTO extends BaseObjectDTO<string> {
  identifier: string;
  context?: ObjectContextDTO;
  expenseDocument: AccountingDocumentDTO;
  /* Revisar */
  award: AwardDTO;
}

export enum TenderingDefinitionViews {
  OA = 'OA',
  ENVELOPE = 'SOBRE',
  PHASE = 'FASE',
  CRITERIA = 'CRITERIO'
}

export enum WorkStateTypeDTO {
  STATELESS = 'stateLess',
  INITIAL = 'initial',
  INPROGRESS = 'inProgress',
  COMPLETED = 'completed'
}

export interface WorkTenderDTO extends BaseObjectDTO<string> {
  identifier: string;
  tenders: TenderV2DTO[];
  state: WorkStateTypeDTO;
}

export interface WorkResultDTO { }

export interface SearchResultDTO {
  content: any;
  singleValue: any;
  singleDescription: any;
  selected: boolean;
  links: Link[];
  enabled: boolean;
  formFilters?: any; // Propiedad de cliente. Valores de formulario filtro. Puede que no conincidan conla báuqeda realizada
}

export class SearchSelectionResultDTO {
  /** El objeto seleccionado del buscador*/
  content: any;
  /** Resultado del findone del objeto seleccionado en un buscador */
  result: any;
}

export class ActionTypeDTO {
  static AUDITAR = 'AUDITAR';
  static VEREXPTE = 'VEREXPTE';
  static FICAHEXPTE = 'FICAHEXPTE';
  static GESTIONGASTO = 'GESTIONGASTO';
  static GESTIONTRAMITES = 'GESTIONTRAMITES';
  static INCIDENCIAS = 'INCIDENCIAS';
  static CRITERIOS = 'CRITERIOS';
  static EXPRELACIONADOS = 'EXPRELACIONADOS';
  static CALENDARIOTRAMITACION = 'CALENDARIOTRAMITACION';
  static NUEVOEXPTE = 'NUEVOEXPTE';
  static PREPARAR = 'PREPARAR';
  static OTROS_DOCUMENTOS = 'OTROS_DOCUMENTOS';
  static CONTROL_EXP = 'CONTROL_EXP';
  static SITUACION = 'SITUACION';
  static ACCESO = 'ACCESO';
  static VERIFICADOR = 'VERIFICADOR';
  static MOVER_EXPEDIENTES = 'MOVER_EXPEDIENTES';
  static NOTIFICACIONES = 'NOTIFICACIONES';
  static INTERESADOS = 'INTERESADOS';
  static VER_RELACIONADOS_PADRES = 'VER_RELACIONADOS_PADRES';
  static VER_RELACIONADOS_HIJOS = 'VER_RELACIONADOS_HIJOS';
  static TASK_LOCK = 'TASK_LOCK';
  static TASK_UNLOCK = 'TASK_UNLOCK';
  static TASK_DISPATCH = 'TASK_DISPATCH';
  static TASK_MANTAIN = 'TASK_MANTAIN';
  static TASK_REDIRECT = 'TASK_REDIRECT';
  static WORK_TO_DO = 'WORK_TO_DO';
  static DOCUMENT_SIGN = 'DOCUMENT_SIGN';
  static DOCUMENT_REJECT = 'DOCUMENT_REJECT';
  static RULE_CANCEL = 'CANCEL_RULE';
  static PROCEDURE_CANCEL = 'CANCEL_PROCEDURE';
  static PROCEDURE_REPAIR = 'REPAIR_PROCEDURE';
  static READJUST_PROCEDURE = 'READJUST_PROCEDURE';
  static SET_PROCEDURE_VARIABLES = 'SET_PROCEDURE_VARIABLES';
  static SET_TASK_VARIABLES = 'SET_TASK_VARIABLES';
  static DOC_GENERATE_CA = 'GENERATE_CA';
  static DOC_CORRECT_DOCUMENT = 'CORRECT_DOCUMENT';
  static DOC_RENAME = 'RENAME_DOCUMENT';
  static DOC_CANCEL = 'CANCEL_DOCUMENT';
  static IMPORT_COMPANY = 'IMPORT_COMPANY';
  static IMPORT_INVOICE = 'IMPORT_INVOICE';
  static CHANGE_STATUS_SITUATION = 'CHANGE_STATUS_SITUATION';
  static IMPORT_CONTRACT = 'IMPORT_CONTRACT';
  static ORGANIZATIONALUNIT_PUBLISH = 'ORGANIZATIONALUNIT_PUBLISH';
  static ORGANIZATIONALUNIT_CHANGELOCATION = 'ORGANIZATIONALUNIT_CHANGELOCATION';
  static EXPORT_TENDER_REQUESTEDMATERIAL: 'EXPORT_TENDER_REQUESTEDMATERIAL';
  static IMPORT_TENDER_REQUESTEDMATERIAL: 'IMPORT_TENDER_REQUESTEDMATERIAL';
  static OPEN_TENDERCLASSIFICATION = 'OPEN_TENDERCLASSIFICATION';
  static OPEN_PROCUREMENTPROJECTLOTSTATEINFO = 'OPEN_PROCUREMENTPROJECTLOTSTATEINFO';
}

export type DataTypeDTO =
  | 'Text'
  | 'String'
  | 'Date'
  | 'Number'
  | 'Range'
  | 'Timestamp';

export type AttributeTypeDTO = 'Query' | 'Data' | 'Script' | 'Unknown';

export class DocumentFileTypeDTO {
  static System = 'System';
  static Draft = 'Draft';
  static Original = 'Original';
  static CertifiedCopy = 'CertifiedCopy';
  static Temporal = 'Temporal';

  static getFileTypePriority(type: DocumentFileTypeDTO): number {
    let priority = 0;
    if (type === DocumentFileTypeDTO.CertifiedCopy) {
      priority = 5;
    } else if (type === DocumentFileTypeDTO.Original) {
      priority = 4;
    } else if (type === DocumentFileTypeDTO.Draft) {
      priority = 3;
    } else if (type === DocumentFileTypeDTO.Temporal) {
      priority = 2;
    } else if (type === DocumentFileTypeDTO.System) {
      priority = 1;
    }
    return priority;
  }
}
export type DocumentConfidencialityLevelDTO =
  | 'NotRestricted'
  | 'LimitedDiffusion'
  | 'Confidential'
  | 'Anonymized';

export type DossierTypeDTO =
  | 'EXP'
  | 'RIL'
  | 'CAT'
  | 'BASE'
  | 'PLAN'
  | 'PROYECTO'
  | 'FEPROYECTO';

export type LinkRelationDTO =
  | 'self'
  | 'parent'
  | 'origin'
  | 'create'
  | 'modify';

export type MasterDataTypeDTO =
  | 'PROCEDIMIENTOSCONTRA'
  | 'FORMASADJUDICACION'
  | 'CLASEEXPTE'
  | 'TIPOGESTION'
  | 'TIPOPAGO'
  | 'CAJAPAGADORA'
  | 'AREORIGGASTO'
  | 'ORDINALPERCEPTOR'
  | 'FORMALIBRAR'
  | 'FORMAPAGO'
  | 'TIPODESCUENTO'
  | 'IDIOMA'
  | 'EXPFASE'
  | 'DOCESTADO'
  | 'UNIDADTIEMPO'
  | 'TIPOBOLETIN'
  | 'PROYINV'
  | 'TIPOEXPTE'
  | 'INCIDENCIA'
  | 'NORMALEGAL'
  | 'CCENTRALIZADA'
  | 'TAUTOELIMINATIVAS'
  | 'PASOAUTO'
  | 'ALIAS'
  | 'TIPOPRESUPUESTO'
  | 'NOT_CANAL'
  | 'NOT_ACTIVIDAD'
  | 'RIL_PODERES'
  | 'ORGANISMO'
  | 'NOT_NUMREPETICIONES'
  | 'CAUSAS_INCIDENCIA'
  | 'TIPOTAREA'
  | 'GARANTIA_MODALIDAD'
  | 'GARANTIA_CONSTITUCION'
  | 'TIPOESTADO'
  | 'TIPOFACTURA'
  | 'TR_TIPO_CIRCUITO'
  | 'DESCDIRECCION'
  | 'COMUNIDAD_AUTONOMA'
  | 'MODALIDADIMPORTE'
  | 'SISTCOMPLEMENTARIO'
  | 'ORGANO_CONTRATANTE_LOCAL'
  | 'MODO_TRAMITACION'
  | 'MONEDA'
  | 'DIRECTORIO_ESTADOS'
  | 'MARCA_TIPO_DOC_SOBRE'
  | 'TIPO_SOBRE'
  | 'PROYECTO_TIPO_APROBACION'
  | 'PROYECTO_ENTIDAD'
  | 'PROYECTO_PARTICIPES'
  | 'PROYECTO_MEDIDAS'
  | 'PROYECTO_CARRETERAS'
  | 'RIL_TIPO_PERSONALIDAD'
  | 'RIL_TIPO_IDENTIFICACION'
  | 'SIN_IDENTIFICAR';

export enum ProcedureStatusDTO {
  TRAMITE_NO_INICIADO = -1,
  TRAMITE_ACTIVO = 0,
  TRAMITE_ERRONEO = 1,
  TRAMITE_FINALIZADO = 2,
  TRAMITE_PAUSADO = 3,
  TRAMITE_CANCELADO = 4,
  SIN_CONEXION = 5,
  TRAMITE_INICIANDO = 6,
  TRAMITE_INICIANDO_REPARACION = 7
}


export type SearchSettingModeDTO = 'SEARCH' | 'EDIT';

export type SearchSettingSubTypeFilterDTO =
  | 'EMPRESAS'
  | 'ORGANISMO'
  | 'CPV'
  | 'CNPA'
  | 'USUARIO'
  | 'PROCEDIMIENTOS_ADJUDICACION'
  | 'TIPOS_TRAMITACION'
  | 'CRITERIOS_ADJUDICACION'
  | 'MODOS_TRAMITACION'
  | 'SISTEMAS_COMPLEMENTARIOS'
  | 'FASES_EXPEDIENTE'
  | 'TIPOS_CONTRATO'
  | 'FORMAS_APROBACION'
  | 'ENTIDADES'
  | 'PARTICIPES'
  | 'CARRETERAS'
  | 'PROYECTO_TIPO_APROBACION';

export class SearchSettingTypeFilterDTO {
  static INTEGER = 'INTEGER';
  static DECIMAL = 'DECIMAL';
  static STRING = 'STRING';
  static YEAR = 'YEAR';
  static DATE = 'DATE';
  static LIST = 'LIST';
  static CHECK = 'CHECK';
  static RANGE_INTEGER = 'RANGE_INTEGER';
  static RANGE_DECIMAL = 'RANGE_DECIMAL';
  static RANGE_YEAR = 'RANGE_YEAR';
  static RANGE_DATE = 'RANGE_DATE';
  static RANGE_LIST = 'RANGE_LIST';
}

export type SignatureValidationPolicy = 'MANDATORY' | 'RECOMMENDATION' | 'NONE';

export type SignatureMode = 'Attached' | 'Detached';

export class SignatureType {
  static XAdES = 'XAdES';
  static CAdES = 'CAdES';
  static PAdES = 'PAdES';
  static PKCS7 = 'PKCS7';
}

export class TaskStatusDTO {
  static READY = 'READY';
  static LOCKED = 'LOCKED';
  static LOGICAL_LOCKED = 'LOGICAL_LOCKED';
  static COMPLETED = 'COMPLETED';
}
export class TaskTypeDTO {
  static TIPO_FIRMA_MASIVA = 'TIPO_FIRMA_MASIVA';
  static TIPO_FIRMA = 'Sign';
  static TIPO_OPTATIVA = 'Choice';
  static TIPO_ASIGNACION = 'Assign';
  static TIPO_CUMPLIMENTACION = 'Fill';
  static TIPO_VIRTUAL = 'TIPO_VIRTUAL';
  static TIPO_ALARMA = 'Warning';
  //    static TIPO_OTROS = 'TIPO_OTROS';
  static TIPO_OTROS = 'Other';
}
export type TaskVerbsDTO = 'lock' | 'unlock' | 'dispatch' | 'mantain';

export type WorkTypeDTO =
  | 'MESSAGE'
  | 'TASKASSIGNMENT'
  | 'ASSIGNMANAGER'
  | 'DOSSIER_FRC'
  | 'DOC_CONTABLE'
  | 'GEST_GASTO'
  | 'DOSSIER_ASSIGN'
  | 'FICHA_INC'
  | 'FECHA_DEV_GARANTIA'
  | 'TENDER'
  | 'DOSSIER_OF'
  | 'TENDER_EVALUATION'
  | 'TENDER_DEFINITION'
  | 'TENDERCLASSIFICATION'
  | 'CSP_AEAT_DEUDA'
  | 'FICHA_ADJ'
  | 'PUBLICACION_BOC'
  | 'DOSSIER_MC'
  | 'REASSIGN'
  | 'DOSSIER_RIL'
  | 'DOSSIER_EXP'
  | 'RE_CO'
  | 'DOSSIER_F'
  | 'NOTIFICATION'
  | 'CSP_TGSS_DEUDA'
  | 'DOCUMENT'
  | 'DOCUMENTSIGNATURE'
  | 'PROCUREMENT_COMMITEE'
  | 'DOSSIER_ANPR'
  | 'RECO'
  | 'REPLYCA'
  | 'REPLYCA_CBAM'
  | 'COMMUNICATION'
  | 'INVOICES'
  | 'RECEIPT'
  | 'CERTIFICATION'
  | 'ENDORSEMENT'
  | 'PROCUREMENTPROJECT_LOT_STATE_INFO'
  | 'SETTLEMENT'
  | 'GUARANTEE_REFUND'
  | 'REGISTER_FICHA_INC'
  | 'BUDGETARY_PROJECT'
  | 'ORDER_PROJECT'
  | 'SPENDING_PROJECT'
  | 'FINANCE_PROJECT'
  | 'FINANCE_CONTRACT'
  | 'INCOME'
  | 'PROJECT_NOLCSP'
  | 'CODE_INCLUSION'
  | 'CONSULTA_AEAT'
  | 'CONSULTA_TGSS'
  | 'CONSULTA_CCAA'
  | 'PROCEDURE_CIRCUIT'
  | 'PHASE_CHANGE'
  | 'SPENDINGPROJECT'
  | 'CERTIFICATIONPAYMENT';

export class AFirmaFormatType {
  static CAdES = 'CAdES';
  static XAdES = 'XAdES';
  static PAdES = 'PAdES';
  static CMS_PKCS7 = 'CMS/PKCS#7';
  static CAdESTri = AFirmaFormatType.CAdES + 'tri';
  static XAdESTri = AFirmaFormatType.XAdES + 'tri';
  static PAdESTri = AFirmaFormatType.PAdES + 'tri';
}

export type AFirmaAlgorithmType =
  | 'SHA512withRSA'
  | 'SHA384withRSA'
  | 'SHA256withRSA'
  | 'SHA1withRSA';

export class I18nData {
  messageKey: string;
  messageParams: Object;
  constructor(messageKey: string, messageParams?: Object) {
    this.messageKey = messageKey;
    this.messageParams = messageParams;
  }
}

export enum SignatureValidationCode {
  ERROR_INTEGRITY = 'ERROR_INTEGRITY',
  ERROR_CERTIFICATE = 'ERROR_CERTIFICATE',
  ERROR_CERTIFICATE_REVOKED = 'ERROR_CERTIFICATE_REVOKED',
  ERROR_CERTIFICATE_EXPIRED = 'ERROR_CERTIFICATE_EXPIRED',
  ERROR_SIGNATURE = 'ERROR_SIGNATURE',
  ERROR_VALIDATION = 'ERROR_VALIDATION',
  OK = 'OK'
}

// TODO: Cargar dinámicamente
export class DivisionDocumentClassType {
  static _00000 = { identifier: '00000', name: 'Expediente' };
  static _02001 = { identifier: '02001', name: 'Contrato' };
  static _02004 = { identifier: '02004', name: 'Incidencia' };
  static _02103 = { identifier: '02103', name: 'Carpeta Ejecución' };
}

export enum TenderStateDTO {
  INITIAL = 'INITIAL',
  REPAIRING = 'REPAIRING',
  ACCEPTED = 'ACCEPTED',
  REJECTED = 'REJECTED',
  WITH_AMOUNT = 'WITH_AMOUNT',
  WITH_VALUATION = 'WITH_VALUATION',
  CORRECTED = 'CORRECTED',
  CANCELLED = 'CANCELLED'
}

export enum TenderStateDTOV2 {
  INITIAL = '1',
  ACCEPTED = '12',
  REJECTED = '13',
  TOCORRECT = '21'
}

export class ValuationCriteriaDTO implements BaseObjectDTO<number> {
  identifier: number;
  task: TaskDTO;
  links: Link[];
  criteriaId: number;
  numOrder: number;
  tenderValue: number; // valor de la oferta
  scoreValue: number; // puntuacion de la oferta, normalmente igual a tenderValue
  description: string; // COMENTARIO DE LA TABLA CRITERIOS_EVALUACION
  standardizedScoreValue: number; // valor resultante de aplicar funcion de normalizacion a scoreValue
  weightedScoreValue: number; // valor resultante de aplicar ponderación a standardizedScoreValue
  meetsSatisfactionThreshold: boolean; // CUMPLE_UMBRAL_SATISFACCION DE LA TABLA CRITERIOS_EVALUACION
  lot: ProcurementProjectLotDTO;

  static patchDTO(dto: ValuationCriteriaDTO) {
    if (!dto.numOrder) {
      dto.numOrder = 0;
    }
    if (!dto.tenderValue) {
      dto.tenderValue = 0;
    }
    if (!dto.scoreValue) {
      dto.scoreValue = 0;
    }
    if (!dto.standardizedScoreValue) {
      dto.standardizedScoreValue = 0;
    }
    if (!dto.weightedScoreValue) {
      dto.weightedScoreValue = 0;
    }
    if (!dto.meetsSatisfactionThreshold) {
      dto.meetsSatisfactionThreshold = false;
    }
  }
}

export class TenderPartyDTO {
  isSmallOrMediumSizedEnterprise: boolean;
  isTemporaryGroupingOfOperators: boolean;
  company: CompanyDTO;
}

export enum TenderAdmissionStatusCodeDTO {
  INITIAL = 'INITIAL',
  ACEPTED = 'ACEPTED',
  REFUSED = 'REFUSED',
  EXCLUDED = 'EXCLUDED'
}

export class TenderAdmissionStatusDTO {
  statusReason: string;
  statusCode: TenderAdmissionStatusCodeDTO;
}

export class TenderEvaluationDTO {
  subjectiveAwardCriteriaTotalScore: number;
  objectiveAwardCriteriaTotalScore: number;
}

export class TenderEconomicOfferDTO {
  totalAmount: number;
  taxExclusiveAmount: number;
  taxAmount: number;
}

export class TenderEvaluationV2DTO {
  admissionStatus: TenderAdmissionStatusDTO;
  isConsideredAsAbnormallyLowTender: TriStateDTO;
  awardTotalScore: number;
  objectiveAwardCriteriaTotalScore: number;
  subjectiveAwardCriteriaTotalScore: number;


  // Clasificacion de ofertas
  awardProposal: boolean; // PROPUESTAADJUDICACION
  classificationDate: Date; // FECHACLASIFICACION
  classificationPosition: number; // POSICIONCLASIFICACION
  tiebreakPosition: number; // POSICIONDESEMPATAR
}

export class TenderLotV2DTO {
  identifier: string;
  procurementProjectLot: ProcurementProjectLotDTO;
  tenderEvaluation: TenderEvaluationV2DTO;
  economicOffer: TenderEconomicOfferDTO;
  static patchDTO(dto: TenderLotV2DTO): TenderLotV2DTO {
    if (!dto) {
      dto = new TenderLotV2DTO();
    } else {
      if (!dto.economicOffer) {
        dto.economicOffer = new TenderEconomicOfferDTO();
      }
    }
    return dto;
  }
}

export class TenderSubmissionDTO {
  receptionRegistrationNumber: string;
  isSubmittedAfterDeadline: boolean;
  submissionDate: Date;
}

export class DecipherProcessInfo {
  date: Date;
  deciphered: boolean;
  errorMessage: string;
}

export class ValidationProcessInfo {
  date: Date;
  validated: boolean;
}

export class ElectronicTenderEnvelope implements BaseObjectDTO<number> {
  links: Link[];
  task: TaskDTO;
  identifier: number;
  envelope: EnvelopeDTO;
  submission: ElectronicTenderSubmission;
  decipherProcessInfo: DecipherProcessInfo;
  validationProcessInfo: ValidationProcessInfo;
  date: Date;
  lastModified: Date;
  procurementCommittee: ProcurementCommitteeDTO;
}

export class SubmissionFileDataDTO {
  file: FileDetailsDTO;
  phase: TenderingPhaseDTO;
  hash: string;
}

export enum ElectronicTenderStatusType {
  OK = 'OK',
  PAXE_PENDING = 'PAXE_PENDING',
  FOOTPRINT_PENDING = 'FOOTPRINT_PENDING',
  PAIR_PENDING = 'PAIR_PENDING',
  INVALID_PAXE = 'INVALID_PAXE',
  INVALID_FOOTPRINT = 'INVALID_FOOTPRINT',
  INVALID_PAIR = 'INVALID_PAIR'
}

export class ElectronicTenderSubmission implements BaseObjectDTO<string> {
  links: Link[];
  task: TaskDTO;
  identifier: string;
  tender: TenderV2DTO;
  paxe: SubmissionFileDataDTO;
  footPrint: SubmissionFileDataDTO;
  submittedEnvelopes: Array<ElectronicTenderEnvelope>;
  communication: CommunicationDTO;
  tenderingPhase: TenderingPhaseDTO;
  status: ElectronicTenderStatusType;
}

export class TenderDocumentResultDTO {
  checkResultCode: string;
  documentIsIncluded: boolean;
  documentIsSubsanable: boolean;
}

export class TenderDocumentV2DTO {
  identifier: number;
  envelope: any;
  documentFileHistory: Array<any>;
  relatedEnvelopeDocumentDefinition: any;
  relatedCompany: CompanyDTO;
  documentName: string;
  documentFile: DocumentFileDTO;
  documentCheckResult: TenderDocumentResultDTO;

  static patchDTO(dto: TenderDocumentV2DTO): TenderDocumentV2DTO {
    if (!dto) {
      dto = new TenderDocumentV2DTO();
    } else {
    }
    return dto;
  }
}

export class TenderV2DTO {
  identifier: string;
  // extendedDataIdentifier: string;
  task: TaskDTO;
  documentClass: DocumentClassDTO;
  division: DivisionDTO;
  labels: any;

  orderNumber: number;
  isWarrantyFreeOffer: boolean;

  document: DocumentDTO;
  tendererParty: TenderPartyDTO;
  description: string;
  tenderLots: Array<TenderLotV2DTO>;
  isElectronicTender: boolean;
  isInclusiveOffer: boolean;
  envelopeDocuments: Array<any>;
  tenderSubmission: TenderSubmissionDTO;
  electronicTenderSubmission: Array<ElectronicTenderSubmission>;
  project: ProcurementProjectDTO;
  validationResult: ValidationResultDTO;
  tenderEnvelopeDocuments: Array<TenderEnvelopeDocumentDTO>;

  static patchDTO(dto: TenderV2DTO): TenderV2DTO {
    if (!dto) {
      dto = new TenderV2DTO();
    } else {
      if (!dto.tendererParty) {
        dto.tendererParty = new TenderPartyDTO();
      }
      if (!dto.tenderSubmission) {
        dto.tenderSubmission = new TenderSubmissionDTO();
      }
      if (!dto.tenderLots) {
        dto.tenderLots = [] as Array<TenderLotV2DTO>;
      }
      if (!dto.envelopeDocuments) {
        dto.envelopeDocuments = [];
      }
      if (!dto.electronicTenderSubmission) {
        dto.electronicTenderSubmission = [] as Array<ElectronicTenderSubmission>;
      }
    }
    return dto;
  }
}

export class TenderEnvelopeDocumentResultDTO {
  checkResultCode: string;
  documentIsIncluded: boolean;
  documentIsSubsanable: boolean;
}

export class TenderEnvelopeDocumentDTO {
  identifier: any;
  tender: TenderV2DTO;
  envelope: EnvelopeDTO;
  documentName: string;
  documentFile: FileDetailsDTO;
  documentCheckResult: TenderEnvelopeDocumentResultDTO;
  relatedEnvelopeDocumentDefinition: any;
  relatedCompany: CompanyDTO;

  task: TaskDTO;

  static patchDTO(dto: TenderEnvelopeDocumentDTO): TenderEnvelopeDocumentDTO {
    if (!dto) {
      dto = new TenderEnvelopeDocumentDTO();
    } else {
      if (!dto.documentCheckResult) {
        dto.documentCheckResult = new TenderEnvelopeDocumentResultDTO();
      }
    }
    return dto;
  }
}

export class TenderDTO {
  //  idLot: string;
  identifier: string;
  task: TaskDTO;
  amount: 0;
  numRegister: string;
  name: string;
  comment: '';
  ute: false;
  description: string;
  accept: false;
  exemptGuarantee: false;
  amountwithoutTax: 0;
  amountTax: 0;
  economicEvaluation: 0;
  tecnicEvaluation: 0;
  dateTender: Date;
  electronic: true;
  company: CompanyDTO;
  contactMail: string;
  document: DocumentDTO;
  tenderEnvelopes: TenderEnvelopeDTO[];
  state: TenderStateDTO;
  tenderLot: boolean;
  tendersLots: Array<TenderLot>;
  valuationCriteria: Array<ValuationCriteriaDTO>;
  orderNumber: number;
  tendererParty: TendererPartyDTO;
}

export class TendererPartyDTO {
  company: CompanyDTO;
  isSmallOrMediumSizedEnterprise: boolean;
  isTemporaryGroupingOfOperators: boolean;
  contactEMail: string;
}

export enum TenderLotState {
  INITIAL = 'INITIAL',
  ADMITTED = 'ADMITTED',
  REJECTED = 'REJECTED',
  EXCLUDED = 'EXCLUDED'
}

export enum TriStateDTO {
  UNDEFINED = 'UNDEFINED',
  YES = 'YES',
  NO = 'NO'
}

export class TenderLot {
  amount: number;
  amountTax: number;
  amountwithoutTax: number;
  awardProposal: boolean;
  context: any;
  economicEvaluation: number;
  identifier: string;
  task: TaskDTO;
  links: Link[];
  punctuation: number;
  positionClassification: number;
  recklessLow: TriStateDTO;
  state: TenderLotState; // "ADMITTED"
  tecnicEvaluation: number;
  motivationState: string;
  // utilizado por el cliente
  tender: TenderDTO;
}

export class TenderEnvelopeDTO {
  identifier: string;
  envelopeDescription: string;
  envelope: EnvelopeDTO;
  procurementCommittee: WorkProcurementCommitteeDTO;
  valid: boolean;
  dateDecipher: Date;
  decipher: boolean;
  decipherErrorMessage: boolean;
  documentEnvelope: DocumentEnvelopeDTO[];
  // indica si todos los documentos del sobre han sido consultado
  seeAll: boolean;
}

export class DocumentEnvelopeDTO {
  identifier: string;
  task: TaskDTO;
  included: boolean;
  corrected: boolean;
  refused: boolean;
  nameDocument: string;
  envelope: any;
  file: FileDetailsDTO;
  filesHistory: any[];
  see: boolean;
  observations: string;
  tender: TenderDTO;
  // propiedades utilizados en el cliente para referenciar a DTO's padre
  tenderEnvelope: TenderEnvelopeDTO;
}

export class MemberProcurementCommitteeDTO {
  parent: ProcurementProjectDTO;
  certificatePerson: CertificatePersonDTO;
  identifier: any;
  task: TaskDTO;
  profile: ProfileDTO;
  releasedFragment: boolean;
  dateGenerationSecrets: Date;
  tendersFragments: TenderFragmentDTO[];
  user: UserDTO;
  signature: SignatureDTO;
}

export class SignatureVerificationDTO {
  error: boolean;
  fatalError: boolean;
  comment: string;
  integrityValid: boolean;
  certificate: any;
  validationMessages: string[];
  certificateMessage: string;
  issuer: string;
}

export class SignatureDTO implements BaseObjectDTO<string> {
  links: Link[];
  signatures: SignatureDTO[];
  allSignatures: SignatureDTO[];
  download: DownloadableDTO;
  date: Date;
  effectiveDate: Date;
  signer: string;
  file: FileDetailsDTO;
  identifier: string;
  task: TaskDTO;
  signatureFormat: SignatureFormatDTO;
  verification: SignatureVerificationDTO;
  user: UserDTO;
  supportUser: UserDTO;
  accountingUser: UserDTO;
  position: string;
  remarks: string;
  handWritten: boolean;
  legacy: boolean;

  static getSignatures(fileDetails: FileDetailsDTO): Array<SignatureDTO> {
    let signatures: Array<SignatureDTO> = [];

    if (fileDetails.signatures) {
      for (let i = 0; i < fileDetails.signatures.length; ++i) {
        signatures.push(fileDetails.signatures[i]);
        SignatureDTO.loadSignatures(fileDetails.signatures[i], signatures);
      }
    }

    return signatures;
  }

  static loadSignatures(
    signature: SignatureDTO,
    signatures: Array<SignatureDTO>
  ) {
    if (signature.signatures) {
      for (let i = 0; i < signature.signatures.length; ++i) {
        signatures.push(signature.signatures[i]);
        if (signature.signatures.length !== 0) {
          this.loadSignatures(signature.signatures[i], signatures);
        }
      }
    }
  }
  static isValidSignature(signature: SignatureDTO): boolean {
	    return this.isValid(signature) == 1;
	  }
  
  static isValid(signature: SignatureDTO): number {
	    if (!signature.verification)
	      return -1;
	    if (
	      signature.verification.error ||
	      !signature.verification.integrityValid ||
	      !signature.verification.certificate.ok
	    ) {
	      return 0;
	    } else {
	      return 1;
	    }
	  }
	}

export class SignatureCommentDTO {
  origin: string; // inbox, substitution, general
  comment: string;
}

export class SignatureCommentsListDTO {
  suggestedComments: Array<SignatureCommentDTO>;
  editable: boolean;
  selectable: boolean;

  identifier: string;
  task: TaskDTO;
}

export class CertificatePersonDTO {
  certificate: CertificateDetailsDTO;
}

export class TenderFragmentDTO {
  identifier: any;
  tender: TenderDTO;
  decoded: boolean;
  envelopeType: any;
  memberProcurementCommittee: MemberProcurementCommitteeDTO;
  fragment: string;
  secret: string;
}

export class HttpResponseError {
  error: string;
  message: string;
  path: string;
  status: number;
  timestamp: Date;
}

export function getSimpleIdentifier<ID, T>(
  identifier: ISubordinateIdDTO<ID, T>
): string {
  let val: string = identifier ? identifier.toString() : undefined;
  return getSimpleIdentifierFromString(val);
}

export function getSimpleIdentifierFromString(identifier: string): string {
  if (typeof identifier === 'string' && identifier.indexOf('<>') !== -1) {
    identifier = identifier.toString().substring(0, identifier.indexOf('<>'));
  }
  return identifier;
}
export function getParentIdentifierFromString(identifier: string): string {
  if (typeof identifier === 'string' && identifier.indexOf('<>') !== -1) {
    identifier = identifier.toString().substring(identifier.indexOf('>') + 1);
  }
  return identifier;
}
export function createIdentifier(identifier: string, type: string) {
  return identifier + '<>' + type;
}

export function normalizaDossierId(dossierId: string): string {
  return (dossierId) ? (dossierId.substring(0, 4) + '/' + dossierId.substring(4)) : undefined;
}

export function deNormalizaDossierId(dossierId: string): string {
  if (dossierId.indexOf('/') > 0) {
    return dossierId.substring(0, 4) + dossierId.substring(5);
  } else {

    return dossierId;
  }

}
export interface TemplateDTO extends BaseObjectDTO<string> {
  description: string;
  date: Date;
  documentClass: MasterDataDTO;
  entity: String;
  active: boolean;
  typeCode: MasterDataDTO;
  applicableLegislation: MasterDataDTO;
  complementarySystem: MasterDataDTO;
  application: string;
  organizationalUnit: OrganizationalUnitDTO;
  params: TemplateParamDTO[];
}

export class TemplateParamDTO {
  name: string;
  value: string;
}

export class FavouriteProjectDTO {
  project: ProjectEntityDTO;
  user: UserDTO;
  relation: string;
  identifier: string;
  task: TaskDTO;
}

/* DTOs FE */
export class ProjectDefinitionGroupDTO {
  identifier: string;
  name: string;
}
export class ProcurementProjectDefinitionsDTO {
  definitions: Array<ProcurementProjectStepsDefinitionDTO>;
  groups: Array<ProjectDefinitionGroupDTO>;
}

export class ProjectDefaultFieldDTO {
  jsonField: string;
  value: string;
}

export class ProcurementProjectStepsDefinitionDTO {
  identifier: string;
  formUUID: string;
  name: string;
  img: string;
  description: string;
  // params: Array<any>;
  default: any;
  configurations: string;
  validationsGroup: string;
  steps: Array<ProcurementProjectStepDTO>;
  profiles: string;
  route: string;
  defaultFields: Array<ProjectDefaultFieldDTO>;
  group: string;

}

export class ProcurementProjectStepDTO {
  label: string;
  value: number;
  formConfig: string;
  validationsGroup: string;
  lastStep: boolean;
}

export class PropertyDTO implements IObjectDTO<string> {
  identifier: string;
  task: TaskDTO;
  clientProperty: boolean;
  description: string;
  group: string;
  section: string;
  uuid: string;
  value: string;
}

export class ActionDefinitionResult {
  description: string;
  objectResult: any;
  file: FileDetailsDTO;
}

export class ElementVisibilityStateDTO {
  type: string;
  elementId: string;
  opened: boolean;
  visible: boolean;
}

export class ElementsVisibilityState {
  panels: Array<ElementVisibilityStateDTO>;
  activeDashboard: string;
}

export interface WorkDebtInquiriesDTO extends BaseObjectDTO<string> {
  identifier: string;
  context?: ObjectContextDTO;
  debtInquiries: DebtInquiriesDTO;
}

export enum CircuitFilterModoInicioTramiteDTO {
  NUEVO_TRAMITE, SUBSANACION
}

export enum TypeStepDTO {
  Anexa = 'Anexa',
  Corrige = 'Corrige',
  Cumplimenta = 'Cumplimenta',
  Firma = 'Firma',
  Revisa = 'Revisa',
  Valida = 'Valida',
  MsgAnexa = 'MsgAnexa',
  MsgCorrige = 'MsgCorrige',
  MsgCumplimenta = 'MsgCumplimenta',
  MsgFirma = 'MsgFirma',
  MsgRevisa = 'MsgRevisa',
  MsgValida = 'MsgValida'
}

export class CircuitStepDTO {
  idMessage: String;
  inbox: InboxDTO;
  profile: ProfileDTO;
  // stepRol: RolStepDTO
  typeStep: TypeStepDTO;
}

export enum CircuitCommunicationAgentTypeDTO {
  ALIAS = 'ALIAS',
  COMPANY = 'COMPANY'
}

export class CircuitCommunicationAgentDTO {
  type: CircuitCommunicationAgentTypeDTO;
  alias: string;
  company: CompanyDTO;
}

export class CircuitCommunicationDTO {
  activity: CommunicationActivityDTO;
  channel: CommunicationChannelDTO;
  receivers: Array<CircuitCommunicationAgentDTO>;
}

export class CircuitConfigDTO {
  listCircuitStepDTO: Array<CircuitStepDTO>;
  publications: Array<CircuitCommunicationDTO>;
  notifications: Array<CircuitCommunicationDTO>;
  advancedMode: boolean;
}

export class CircuitDTO extends BaseObject {
  alias: string;
  documentClass: DocumentClassDTO;
  modoInicioTramite: CircuitFilterModoInicioTramiteDTO;
  name: string;
  nameCircuit: string;
  organizationalUnit: OrganizationalUnitDTO;
  origin: string;
  phase: MasterDataDTO;
  processingMode: MasterDataDTO;
  typeCircuit: MasterDataDTO;
  uuid: string;
  config: CircuitConfigDTO;
}

export class ProcedureCircuitDTO implements BaseObjectDTO<string> {
  links: Link[];
  identifier: string;
  task: TaskDTO;
  context?: ObjectContextDTO;
  division: DivisionDTO
  orderNumber: number;
  circuit: CircuitDTO;
  procedure: ProcedureDTO;
  validationResult: ValidationResultDTO;
}

export class ProfileInboxDTO {
  profile: ProfileDTO;
  inbox: InboxDTO;
}

export interface WorkProcedureCircuitDTO extends BaseObjectDTO<string> {
  circuitsDocuments?: Array<DocumentClassDTO>;
  orderNumber?: number;
  phase?: MasterDataDTO;
  procedureCircuit?: ProcedureCircuitDTO;
  mustBeNotified?: boolean;
  notificationConfig?: Array<CircuitCommunicationDTO>
  mustBePublished?: boolean;
  publishConfig?: Array<CircuitCommunicationDTO>;
  companyTaxIdentifier?: string
  inboxSugestions?: Array<ProfileInboxDTO>;
  documentClassSearchId?: string;
  desiredLocale: string;
}
